
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_8493_4548)"}},[_c('path',{attrs:{"d":"M10.335 4.196c.738-.254 1.191-1.757.8-2.39.015.407-.715.714-.97.278C10.002 1.377 11.369.69 12 .6c-.3-.451-1.95-.65-2.547.167-.402.55-.28.91-.813.706C8.056 1.249 8.565.446 9.033.3 7.19-.041 7.662 1.847 6.97 1.665 6.279 1.484 6.926.9 7 .823c-1.24-.198-.945 1.093-1.904 1.342-.568.213-.898.255-1.204.308A4.693 4.693 0 109.36 7.604c.026-.244.132-.536.225-.753.286-.668 1.097-.907 1.294-1.22.442-.702.085-1.143.085-1.143s-.164.416-.63.46c-.467.045-.736-.497 0-.752zm-9.2 3.27c-.284 0-.513-.274-.513-.613 0-.34.23-.614.512-.614.283 0 .512.275.512.614 0 .339-.23.614-.512.614zM2.66 9.085c-.3.077-.612-.127-.695-.456-.084-.328.092-.657.392-.733.3-.077.612.128.695.457.084.328-.092.656-.392.732zm.552-1.99c-.32-.013-.568-.298-.554-.636.013-.34.283-.604.602-.591.32.013.568.298.555.636-.014.34-.284.604-.603.591zm5.61-.213h-.206a3.778 3.778 0 00-.281-1.311 4.046 4.046 0 00-.885-1.327c-.4-.4-.865-.698-1.327-.885-.462-.19-.92-.27-1.311-.28V2.87c.412-.012.904.035 1.415.21.51.17 1.034.474 1.472.913.439.438.742.963.914 1.472.174.51.22 1.003.208 1.415z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_8493_4548"}},[_c('path',{attrs:{"d":"M0 0h12v12H0z"}})])])])
          )
        }
      }
    